﻿import TKCustomElementFactory from '@tk/utilities/tk.custom.element.factory';
import { fetchRequest } from '@tk/utilities/tk.fetch';
import render from '@tk/utilities/tk.render';

export default class KWAsyncContentLoader extends TKCustomElementFactory {
    asyncURL?: string;
    observer: IntersectionObserver;
    options: IntersectionObserverInit;
    hasLoaded: boolean = false;

    constructor() {
        super();
        this.asyncURL = this.getAttribute('data-tk-url') || undefined;
        this.options = {
            root: document,
            rootMargin: '0px',
            threshold: 1.0,
        };
        this.observer = new IntersectionObserver(this.handleObserver.bind(this), this.options);
    }

    connectedCallback(): void {
        if (!this.asyncURL) throw new Error('Async Content Loader: URL not defined!');
        this.observer.observe(this);
    }

    disconnectedCallback(): void {
        super.disconnectedCallback();
        this.observer.unobserve(this);
    }

    loadData() {
        fetchRequest({
            requestURL: this.asyncURL!,
            resolveHandler: this.handleResponse.bind(this),
        });
    }

    handleResponse(response: TKResponse) {
        if (!response || !response.success) return;
        const body = render(response.dataAsHtml, true);
        this.insertAdjacentHTML('beforeend', body.innerHTML);
    }

    handleObserver(entries: IntersectionObserverEntry[]) {
        entries.forEach((entry) => {
            if (!entry.isIntersecting || this.hasLoaded) return;
            this.loadData();
            this.hasLoaded = true;
        });
    }
}